export default __webpack_public_path__ + "static/media/ms.d64b1246.svg";